blockHeight('.why-block',320);

function blockHeight(block,wWidth){ 
	var $block = $(block),
			defaultWidth = 767,
			minWidth;

	if (wWidth) {
		minWidth = wWidth;
	}else{
		minWidth = defaultWidth;
	}

	function setHeight(){
		if ($(window).outerWidth() > minWidth) {
			var maxHeight = 0;

			$block.each(function(){
				if ($(this).height() > maxHeight) {
					maxHeight = $(this).height();
				}
			})

			$block.height(maxHeight);
		}else{
			$block.css('height', 'auto');
		}
	}
	setHeight();

	$(window).resize(function(){
		if ($(window).outerWidth() > minWidth) {
			var maxHeight = 0;

			$block.each(function(){
				$(this).css('height','auto');

				if ($(this).height() > maxHeight) {
					maxHeight = $(this).height();
				}
			})

			$block.height(maxHeight);
		}else{
			$block.css('height', 'auto');
		}
	})
}